export default {
  apiBaseUrl: process.env.VUE_APP_API_URL || 'https://api.ssotester-temp.dev.swivelpay.com'
}
